export default "__VITE_ASSET__Cgvaf1fX__"